
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { Form as elForm } from "element-ui";
import Pagination from "@/components/paginaiton.vue";
import TimeRange from "../yidongshebei/components/time-range/time-range.vue";
import {
  getZhenciList,
  getTemplateGroup,
  getTemplateList,
  addTemplateGroup,
  addZhenci,
  deleteMenzhen,
} from "@/request/doctor";
@Component({
  components: {
    Pagination,
    TimeRange,
  },
})
export default class Name extends Vue {
  private filter: any = {
    startTime: null,
    endTime: null,
    current_page: 1,
    page_count: 10,
    totalCount: 0,
  };
  private list: any = [];
  private ifMuban: boolean = false;
  private ifLiangbiao: boolean = false;
  private ifMubanName: boolean = false;
  private cMuban: any = "";
  private data: any = {};
  private leftData: any = {
    基本信息类: [],
    实验室检查类: [],
    健康测评类: [],
  };
  private templateGroup: any = [];
  private rightData: any = {
    基本信息类: [],
    实验室检查类: [],
    健康测评类: [],
  };
  private liangbiaoTotal: any = 11;
  private leftSel: any = {
    基本信息类: [],
    实验室检查类: [],
    健康测评类: [],
  };
  private rightSel: any = {
    基本信息类: [],
    实验室检查类: [],
    健康测评类: [],
  };
  private liangbiaoSel: any = 0;
  private liangbiaoTem: any = ["基本信息类", "实验室检查类", "健康测评类"];
  private leftCheckedAll: any = false;
  private rightCheckedAll: any = false;
  private nameData: any = {
    name: "",
  };
  private nameRules: any = {
    name: [{ validator: this.checkName, trigger: "blur" }],
  };
  private checkName(rule: any, value: any, callback: any) {
    if (!value) {
      return callback(new Error("请输入模板名称"));
    } else {
      if (value.length > 10) {
        callback(new Error("最多不能超过10个字"));
      } else {
        callback();
      }
    }
  }
  private get user() {
    return this.$store.state.user || {};
  }
  private get patient() {
    return this.$store.state.patient;
  }
  private deleteOne(item: any) {
    const params = {
      data: {
        zhenci_id: item.zhenci_id,
      },
    };
    console.log(params);
    // return;
    deleteMenzhen(this, params).then((res: any) => {
      this.$message.success("删除成功");
      this.getList();
    });
  }
  private isShowTitle(items: any) {
    let result = false;
    items.forEach((ele: any) => {
      if (!ele.hide) {
        result = true;
      }
    });
    return result;
  }
  private getNum(item: any) {
    let num = 0;
    this.liangbiaoTem.forEach((element: any) => {
      item[element].forEach((ele: any) => {
        if (!ele.hide) {
          num++;
        }
      });
    });
    return num;
  }
  private addMenzhen() {
    this.ifMuban = true;
    getTemplateGroup(this).then((res: any) => {
      this.templateGroup = res;
    });
  }
  private goRead(items: any) {
    this.$router.push({
      path: "/main/patient/dangan-menzhen-edit",
      query: {
        zhenci_id: items.zhenci_id,
        type: "read",
      },
    });
  }
  private goDetail(items: any) {
    this.$router.push({
      path: "/main/patient/dangan-menzhen-edit",
      query: {
        zhenci_id: items.zhenci_id,
        type: "edit",
      },
    });
  }
  private saveMuban() {
    let templates: any = [];
    this.liangbiaoTem.forEach((ele: any) => {
      this.rightData[ele].forEach((items: any) => {
        if (!items.hide) {
          templates.push({
            template_id: items.template_id,
          });
        }
      });
    });
    (this.$refs.nameForm as elForm).validate((isValid: boolean) => {
      if (isValid) {
        console.log("保存模板");
        // 保存模板
        const params = {
          名称: this.nameData.name,
          templates: templates,
        };
        addTemplateGroup(this, params).then((res: any) => {
          this.$message.success("保存模板成功");
          const params = {
            patient_id: this.patient.patient_id,
            template_group_id: res,
          };
          addZhenci(this, params).then((zhenci: any) => {
            this.$router.push({
              path: "/main/patient/dangan-menzhen-edit",
              query: {
                zhenci_id: zhenci,
              },
            });
          });
        });
      }
    });
  }
  private openSave(type: any) {
    let templates: any = [];
    this.liangbiaoTem.forEach((ele: any) => {
      this.rightData[ele].forEach((items: any) => {
        if (!items.hide) {
          templates.push({
            template_id: items.template_id,
          });
        }
      });
    });
    if (templates.length === 0) {
      this.$message.warning("请先添加量表到右边！");
      return;
    }
    if (type) {
      this.ifMuban = false;
      this.ifMubanName = true;
    } else {
      const params = {
        patient_id: this.patient.patient_id,
        template_ids: templates,
      };
      addZhenci(this, params).then((zhenci: any) => {
        this.$router.push({
          path: "/main/patient/dangan-menzhen-edit",
          query: {
            zhenci_id: zhenci,
          },
        });
      });
    }
  }
  private changeLeft(type: any, index: any) {
    console.log("changeLeft");
    this.leftData[type][index]["checked"] = true;
  }
  private changeRight(type: any, index: any) {
    this.rightData[type][index]["checked"] = true;
  }
  private leftSelAll() {
    this.leftSel = { 基本信息类: [], 实验室检查类: [], 健康测评类: [] };
    if (this.leftCheckedAll) {
      // 选中全部
      this.liangbiaoTem.forEach((item: any) => {
        this.leftData[item].forEach((ele: any) => {
          if (!ele.hide) {
            ele.checked = true;
            this.leftSel[item].push(ele);
          }
        });
      });
    } else {
      // 取消全部选择
      this.liangbiaoTem.forEach((item: any) => {
        this.leftData[item].forEach((ele: any) => {
          ele.checked = false;
        });
      });
    }
  }
  private rightSelAll() {
    this.rightSel = { 基本信息类: [], 实验室检查类: [], 健康测评类: [] };
    if (this.rightCheckedAll) {
      // 选中全部
      this.liangbiaoTem.forEach((item: any) => {
        this.rightData[item].forEach((ele: any) => {
          if (!ele.hide) {
            ele.checked = true;
            this.rightSel[item].push(ele);
          }
        });
      });
    } else {
      // 取消全部选择
      this.liangbiaoTem.forEach((item: any) => {
        this.rightData[item].forEach((ele: any) => {
          ele.checked = false;
        });
      });
    }
  }
  private toLeft() {
    console.log("toLeft");
    this.liangbiaoTem.forEach((item: any) => {
      this.rightSel[item].forEach((ele: any) => {
        this.leftData[item].forEach((e: any) => {
          if (ele.template_id === e.template_id) {
            // 改变左边数据
            e.checked = false;
            e.hide = false;
            // 改变右边数据
            ele.hide = true;
            ele.checked = false;
          }
        });
      });
    });
    // 清除左边选中的
    this.rightSel = {
      基本信息类: [],
      实验室检查类: [],
      健康测评类: [],
    };
    this.leftCheckedAll = false;
    this.rightCheckedAll = false;
    this.$forceUpdate();
  }
  private toRight() {
    console.log("toRight");
    this.liangbiaoTem.forEach((item: any) => {
      this.leftSel[item].forEach((ele: any) => {
        this.rightData[item].forEach((e: any) => {
          if (ele.template_id === e.template_id) {
            // 改变右边数据
            e.checked = false;
            e.hide = false;
            // 改变左边数据
            ele.hide = true;
            ele.checked = false;
          }
        });
      });
    });
    // 清除左边选中的
    this.leftSel = {
      基本信息类: [],
      实验室检查类: [],
      健康测评类: [],
    };
    this.leftCheckedAll = false;
    this.rightCheckedAll = false;
    this.$forceUpdate();
  }
  /**
   * @description 处理页码变化
   */
  private handleCurrentPageChange(val: any) {
    this.filter.current_page = val;
    this.getList();
  }
  /**
   * @description 处理翻页器的每页条数变化
   */
  private handleCurrentSizeChange(val: any) {
    this.filter.current_page = 1;
    this.filter.page_count = val;
    this.getList();
  }
  private timeChange(d: any) {
    this.filter = JSON.parse(JSON.stringify(d));
    this.refresh();
  }
  private refresh() {
    this.filter.current_page = 1;
    this.getList();
  }
  private getList() {
    const params = {
      begin_date: this.filter.startTime,
      end_date: this.filter.endTime,
      patient_id: this.patient.patient_id,
      current_page: this.filter.current_page,
    };
    getZhenciList(this, params).then((res: any) => {
      this.list = res.zhencis;
      this.filter.totalCount = res.total_count;
    });
  }
  private selectMuban() {
    if (!this.cMuban) {
      this.ifMuban = false;
      this.ifLiangbiao = true;
      // 获取可选模板内容
      getTemplateList(this).then((res: any) => {
        this.data = res;
        this.liangbiaoTem.forEach((item: any) => {
          this.data[item].forEach((ele: any) => {
            ele.checked = false;
          });
        });
        this.leftData = JSON.parse(JSON.stringify(this.data));
        this.rightData = JSON.parse(JSON.stringify(this.data));
        // 右边全部为隐藏状态
        this.liangbiaoTem.forEach((item: any) => {
          this.rightData[item].forEach((ele: any) => {
            ele.hide = true;
          });
        });
      });
    } else {
      const params = {
        patient_id: this.patient.patient_id,
        template_group_id: this.cMuban,
      };
      addZhenci(this, params).then((res: any) => {
        this.$router.push({
          path: "/main/patient/dangan-menzhen-edit",
          query: {
            zhenci_id: res,
          },
        });
      });
    }
  }
  mounted() {
    this.getList();
  }
}
